/**
 * ערכי productType מנורמלים ל-audit / אדמין.
 */
export const PRICING_AUDIT_PRODUCT_TYPE = Object.freeze({
  HOTEL: "hotel",
  VACATION_PACKAGE: "vacation_package",
  ORGANIZED: "organized",
  FLIGHT: "flight",
});

/**
 * ממפה מחרוזות מקור (טאב חיפוש, dealType LDS וכו') לערך מנורמל, או undefined אם אין מיפוי ברור.
 * @param {unknown} raw
 * @returns {string|undefined}
 */
export function normalizePricingAuditProductType(raw) {
  if (raw == null || raw === "") return undefined;
  const key = String(raw)
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");
  if (!key) return undefined;

  if (key === "hotel" || key === "hotels") return PRICING_AUDIT_PRODUCT_TYPE.HOTEL;

  if (
    key === "flightshotel" ||
    key === "flighthotel" ||
    key === "packages" ||
    key === "package" ||
    key === "dynamicpackages" ||
    key === "dynamicpackage" ||
    key === "vacationpackages" ||
    key === "vacationpackage"
  ) {
    return PRICING_AUDIT_PRODUCT_TYPE.VACATION_PACKAGE;
  }

  if (
    key === "organizedtour" ||
    key === "organizedtours" ||
    key === "organized" ||
    key === "tour" ||
    key === "tours"
  ) {
    return PRICING_AUDIT_PRODUCT_TYPE.ORGANIZED;
  }

  if (
    key === "planes" ||
    key === "plane" ||
    key === "flights" ||
    key === "flight"
  ) {
    return PRICING_AUDIT_PRODUCT_TYPE.FLIGHT;
  }

  return undefined;
}
